import "./RegistrationInfoPage.scss";
import { Button, Content, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";

const NoDiplomaRegistrationInfoPage = () => {
  const translate = useTranslator();
  // TODO connect to the student registration form
  return (
    <Page>
      <Content width={"slim"} centeredTitle={true} centeredTexts={true}>
        <div className="registration-info-page">
          <h1 className="productive-heading-04 sia-text-12">{translate("wizard.registeration-options.no-diploma.title")}</h1>
          <div className="registration-info-page__button">
            <Button>{translate("wizard.registeration-options.no-diploma.button.label")}</Button>
          </div>
        </div>
      </Content>
    </Page>
  );
};

export default NoDiplomaRegistrationInfoPage;
